import type { ReactNode } from "react";

interface SearchSectionHeadingProps {
  label: string;
  action?: ReactNode;
}

export const SearchSectionHeading = ({ label, action }: SearchSectionHeadingProps) => (
  <div className="flex items-center gap-2 px-3 pb-1 pt-2.5">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
      {label}
    </span>
    <span className="h-px flex-1 bg-border/50" />
    {action}
  </div>
);
